export default __webpack_public_path__ + "static/media/marker1.9db2378e.png";